"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SinglePickupVoucherPanel = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require("redux-form");

var _reactRouter = require("react-router");

var _PickupVouchersTable = require("./PickupVouchersTable");

var _PickupVouchersTable2 = _interopRequireDefault(_PickupVouchersTable);

var _PickupVoucherPreviewModal = require("../modal/PickupVoucherPreviewModal");

var _PickupVoucherPreviewModal2 = _interopRequireDefault(_PickupVoucherPreviewModal);

var _PickupVoucherForm = require("./PickupVoucherForm");

var _PickupVoucherForm2 = _interopRequireDefault(_PickupVoucherForm);

var _UserPickupVoucherPrint = require("./UserPickupVoucherPrint");

var _UserPickupVoucherPrint2 = _interopRequireDefault(_UserPickupVoucherPrint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SinglePickupVoucherPanel = exports.SinglePickupVoucherPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SinglePickupVoucherPanel, _Component);

  function SinglePickupVoucherPanel(props) {
    (0, _classCallCheck3.default)(this, SinglePickupVoucherPanel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SinglePickupVoucherPanel.__proto__ || (0, _getPrototypeOf2.default)(SinglePickupVoucherPanel)).call(this, props));

    _this.handleModalClose = function () {
      _this.setModalShowing(false, null);
    };

    _this.handlePreview = function (number) {
      _this.setModalShowing(true, number);
    };

    _this.getModalPrintPath = function () {
      var numbers = [_this.state.voucherNumber];
      return _this.getPrintPathWithNumbers(numbers);
    };

    _this.handlePrint = function (event) {
      var _this$props = _this.props,
          updateVoucherPrintInfo = _this$props.updateVoucherPrintInfo,
          voucher = _this$props.voucher;

      var numbers = _this.getNumberValues();

      var data = {
        voucher: voucher,
        numbers: numbers
      };

      if (!numbers || !numbers.length) {
        event.preventDefault();
      } else {
        updateVoucherPrintInfo(data);
      }
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    };

    _this.setModalShowing = function (isShowingModal, voucherNumber) {
      _this.setState({ isShowingModal: isShowingModal, voucherNumber: voucherNumber });
    };

    _this.setNumbersForPrint = function (count) {
      var voucher = _this.props.voucher;

      var printed = voucher.quantity_printed || 0;

      var used = voucher.quantity_printed + count;
      var numbers = {};
      for (var i = 0; i < voucher.quantity; i++) {
        var number = voucher.first_voucher_id + i;
        if (i < used) {
          numbers[number] = false;
        }
        if (i >= voucher.quantity_printed) {
          numbers[number] = true;
        }
        if (i >= voucher.quantity_printed + count) {
          numbers[number] = false;
        }
      }
      _this.setState({ numbers: numbers });
    };

    _this.toggleNumber = function (number) {
      var numbers = _this.state.numbers;
      numbers[number] = !numbers[number];
      var isAllSelected = !(0, _keys2.default)(numbers).some(function (key) {
        return !numbers[key];
      });
      _this.setState({ numbers: numbers, isAllSelected: isAllSelected });
    };

    _this.toggleAllNumbers = function () {
      var numbers = _this.state.numbers;
      var isAllSelected = !(0, _keys2.default)(numbers).some(function (key) {
        return !numbers[key];
      });
      _this.setState({ isAllSelected: !isAllSelected }, function () {
        _this.setCheckboxes(!isAllSelected);
      });
    };

    _this.state = {
      isShowingModal: false,
      voucherNumber: null,
      numbers: {}
    };
    return _this;
  }

  (0, _createClass3.default)(SinglePickupVoucherPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var voucher = this.props.voucher;

      var vouchersAvailable = voucher.quantity - (voucher.quantity_printed || 0);
      this.setNumbersForPrint(vouchersAvailable);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps) {
      if (this.props.vouchersInfoUpdated) {}
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          voucher = _props.voucher,
          fields = _props.fields;

      var vouchersAvailable = voucher.quantity - (voucher.quantity_printed || 0);
      var divStyle = {
        justifyContent: "center",
        alignItems: "center",
        marginTop: 11
      };

      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(
                "h1",
                { className: "h3" },
                "Noutolipukkeet"
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-md-6" },
              _react2.default.createElement(
                "h2",
                { className: "h4" },
                "Tilausnumero: ",
                voucher.order_id
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Huomioithan:"
                ),
                " Kutakin yksil\xF6llisesti numeroitua lipuketta voidaan k\xE4ytt\xE4\xE4 valitussa noutopaikassa vain kerran. Jos samalla lipuke- numerolla palautuu useita lipukkeita, laskutetaan ne automaattisesti. Laskutukseen lis\xE4t\xE4\xE4n t\xE4ll\xF6in tarkastuslis\xE4 15e / lipuke (alv 0%)."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "i",
                  null,
                  voucher.description
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-md-3" },
              _react2.default.createElement(_PickupVoucherForm2.default, { fields: fields, voucher: voucher })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-sm-3" },
              _react2.default.createElement(_UserPickupVoucherPrint2.default, {
                voucher: voucher,
                vouchersAvailable: vouchersAvailable,
                setNumbersForPrint: this.setNumbersForPrint
              })
            ),
            vouchersAvailable > 0 ? _react2.default.createElement(
              "div",
              { className: "col col-sm-4" },
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  to: this.getPrintPath(),
                  onClick: this.handlePrint,
                  target: "_blank"
                },
                _react2.default.createElement(
                  "div",
                  { className: "button button-set-width text-center" },
                  _react2.default.createElement(
                    "div",
                    { className: "button-text", style: divStyle },
                    "Tulosta"
                  )
                )
              )
            ) : "Kaikki lipukkeet tulostettu"
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(_PickupVouchersTable2.default, {
                vouchersAvailable: vouchersAvailable,
                toggleNumber: this.toggleNumber,
                handlePreview: this.handlePreview,
                numbers: this.state.numbers,
                voucher: voucher,
                location: this.props.location
              })
            )
          )
        ),
        _react2.default.createElement(_PickupVoucherPreviewModal2.default, (0, _extends3.default)({}, this.state, {
          fields: this.props.fields,
          voucher: voucher,
          handleClose: this.handleModalClose,
          printPath: this.getModalPrintPath()
        }))
      );
    }
  }, {
    key: "getPrintPath",
    value: function getPrintPath() {
      var numbers = this.getNumberValues();
      return this.getPrintPathWithNumbers(numbers);
    }
  }, {
    key: "getPrintPathWithNumbers",
    value: function getPrintPathWithNumbers(numbers) {
      var values = this.props.values;

      return {
        pathname: "/tulosta" + this.props.location.pathname,
        query: (0, _extends3.default)({}, values, { numbers: numbers })
      };
    }
  }, {
    key: "getNumberValues",

    /*
      setCheckboxes (value) {
        const { quantity, first_voucher_id } = this.props.voucher;
        let numbers = {};
        for (let i = 0; i < quantity; i++) {
          let number = first_voucher_id + i;
          numbers[number] = value;
        }
        this.setState({numbers});
      }
      */
    value: function getNumberValues() {
      var numbers = this.state.numbers;

      return (0, _keys2.default)(numbers).filter(function (key) {
        if (numbers[key]) {
          return key;
        }
      });
    }
  }]);
  return SinglePickupVoucherPanel;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object.isRequired,
  voucher: _react.PropTypes.object.isRequired,
  values: _react.PropTypes.object.isRequired,
  updateVoucherPrintInfo: _react.PropTypes.func.isRequired
}, _temp);
exports.default = (0, _reduxForm.reduxForm)({
  form: "voucher-form",
  fields: ["address", "postal_area", "contractor", "company", "register_number", "driver", "soil_types"]
})(SinglePickupVoucherPanel);


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/uservouchers/SinglePickupVoucherPanel.js
 ** module id = 1191
 ** module chunks = 0
 **/